<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="queryChange">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('label.batchNo')">
              <j-input :placeholder="$t('label.pleaseSelectBatchNo')" v-model="queryParam.breedBatchCode"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryChange" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>


      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">



      </a-table>
    </div>


  </a-card>
</template>

<script>

    import '@/assets/less/TableExpand.less'
    import { JeecgListMixin } from '@/mixins/JeecgListMixin'
    import {getAction} from '@/api/manage'
    import JDictSelectTag from "@/components/dict/JDictSelectTag"
    import JInput from '@/components/jeecg/JInput'

    export default {
        name: 'EfsMdDeadAmoyLogList',
        mixins:[JeecgListMixin],
        components: {
            JDictSelectTag,
            JInput
        },
        data () {
            return {
                description: '死淘',
                // 表头
                columns: [
                    {
                        title: '#',
                        dataIndex: '',
                        key:'rowIndex',
                        width:60,
                        align:"center",
                        customRender:function (t,r,index) {
                            return parseInt(index)+1;
                        }
                    },
                    {
                        title:'批次编号',
                        align:"center",
                        dataIndex: 'breedBatchCode'
                    },
                    {
                        slotName: 'tableHeader.contractNo',
scopedSlots: { title: 'tableHeader.contractNo'},
                        align:"center",
                        dataIndex: 'conCode'
                    },
                    {
                        title:'账期',
                        align:"center",
                        dataIndex: 'accountCode'
                    },
                    {
                        title:'死淘数量',
                        align:"center",
                        dataIndex: 'deadAmoy'
                    }

                ],
                url: {
                    list: "/efs/efsMdDeadAmoyLog/list",
                },
                dictOptions:{},
            }
        },
        created() {
        },
        computed: {
            importExcelUrl: function(){
                return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
            },
        },
        methods: {
            loadData(arg) {
                if (arg === 1) {
                    this.ipagination.current = 1;
                }
                var params = this.getQueryParams();
                if(params.company){
                    getAction(this.url.list, {breedBatchCode:params.breedBatchCode,companyCode:params.company,accountCode:params.period,pageNo : this.ipagination.current,
                        pageSize :this.ipagination.pageSize}).then((res) => {
                        if (res.success) {
                            this.dataSource = res.result.records;
                            this.ipagination.total = res.result.total;
                        } else {
                            this.dataSource = null;
                        }
                    })
                }

            },
            getOrderMain(company,period) {
                this.queryParam.company = company;
                this.queryParam.period = period;
                this.loadData(1);
            },
            searchReset(){
                this.queryParam.breedBatchCode="";
                this.loadData(1);
            },
            queryChange(){
                this.loadData(1);
            },
            initDictConfig(){
            }
        }
    }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>